import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

type OaiqFn = {
  (...args: unknown[]): void;
  q: unknown[];
};

declare global {
  interface Window {
    oaiq?: OaiqFn;
  }
}

function measurePageViewed() {
  window.oaiq?.("measure", "page_viewed", { type: "contents" });
}

/** SPA rota değişiminde OpenAI `page_viewed`. İlk boyama `oaiq-init.js` içinden gider. */
export function OpenAIPixel() {
  const { pathname, search } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = `${pathname}${search}`;
    if (lastPath.current === null) {
      lastPath.current = path;
      return;
    }
    if (lastPath.current === path) return;
    lastPath.current = path;

    if (typeof window.oaiq === "function") {
      measurePageViewed();
      return;
    }

    const started = Date.now();
    const timer = window.setInterval(() => {
      if (typeof window.oaiq === "function") {
        window.clearInterval(timer);
        measurePageViewed();
        return;
      }
      if (Date.now() - started >= 8000) window.clearInterval(timer);
    }, 50);

    return () => window.clearInterval(timer);
  }, [pathname, search]);

  return null;
}
